import axios from "axios";
import { pushSportsbooksToQueryField } from '../sportsbookAliases';

export const getArbitrageResults = async (email, filters, is_live = false, token) => {

	try {
		const queryRows = [];
		// console.log('filters: ', filters);

		let fltrs = filters;
		if (!fltrs) {
			const userdb = JSON.parse(window.localStorage.getItem('userdb'))
			const preferredSportsbooks = userdb?.preferred_sportsbooks;

			let sportsbooks = []
			if (preferredSportsbooks?.length > 0) {
				for (const bk of preferredSportsbooks) {
					sportsbooks.push({label: bk, value: bk})
				}
			} else {
				sportsbooks = [{ label: 'bet365', value: 'bet365' }]
			}

			fltrs = [
				{
					sports: [],
					leagues: [],
					sportsbooks: sportsbooks,
					sharpBooks: [
						{ label: 'WagerWiz Mains', value: 'WagerWiz Mains' },
						{ label: 'WagerWiz Props', value: 'WagerWiz Props' },
					],
					markets: [],
					marketTypes:  [],
					minMaxEv: [-1000, 1000],
					minMaxOdds: [-10000, 10000],
					date: new Date(),
				},
			];
		}

		for (const row of fltrs) {
			const queryRow = {};
			// Ensure dateDifference is set - calculate from date if missing
			if (row.dateDifference === undefined || row.dateDifference === null) {
				if (row.date) {
					const currentTime = Date.now();
					const fourHoursMs = 4 * 60 * 60 * 1000;
					const dateTime = new Date(row.date).getTime();
					const diffTime = dateTime - (currentTime - fourHoursMs);
					queryRow.dateDifference = Math.floor(diffTime / (1000 * 60 * 60 * 24));
				} else {
					// Default to 7 days if no date
					queryRow.dateDifference = 7;
				}
			} else {
				queryRow.dateDifference = row.dateDifference;
			}

			const currentTime = Date.now();
			const fourHoursMs = 4 * 60 * 60 * 1000;
			const futureTime = (currentTime - fourHoursMs) + queryRow.dateDifference * 24 * 60 * 60 * 1000;
			try {
				const futureDate = new Date(futureTime);
				queryRow.date = new Date(futureDate).toISOString();
			} catch(e) {
				const futureDate = new Date();
				queryRow.date = new Date(futureDate).toISOString();
			}
			

			// queryRow.date = new Date(row.date).toISOString();
			queryRow.hide_alternates = row.hide_alternates;
			queryRow.limit = row.limit || '';
			queryRow.default = false;
			queryRow.name = 'temp';
			queryRow.id = 'temp';
			queryRow.league = [];
			queryRow.sport = [];
			queryRow.market = [];
			queryRow.marketType = [];
			queryRow.book = [];
			queryRow.sharp = [];
			queryRow.live = is_live;
			queryRow.include_only_selected_books = row.include_only_selected_books;
			
			// Normalize minMaxOdds - handle null, undefined, empty string, or missing values
			if (!row.minMaxOdds || !Array.isArray(row.minMaxOdds)) {
				queryRow.minMaxOdds = [-10000, 10000];
			} else {
				queryRow.minMaxOdds = [...row.minMaxOdds];
				if (queryRow.minMaxOdds[0] === '' || queryRow.minMaxOdds[0] === null || queryRow.minMaxOdds[0] === undefined) {
					queryRow.minMaxOdds[0] = -10000;
				}
				if (queryRow.minMaxOdds[1] === '' || queryRow.minMaxOdds[1] === null || queryRow.minMaxOdds[1] === undefined) {
					queryRow.minMaxOdds[1] = 10000;
				}
				// Convert to numbers
				queryRow.minMaxOdds = [Number(queryRow.minMaxOdds[0]), Number(queryRow.minMaxOdds[1])];
			}

			// Normalize minMaxEv - handle null, undefined, empty string, or missing values
			if (!row.minMaxEv || !Array.isArray(row.minMaxEv)) {
				queryRow.minMaxEv = [-1000, 1000];
			} else {
				queryRow.minMaxEv = [...row.minMaxEv];
				if (queryRow.minMaxEv[0] === '' || queryRow.minMaxEv[0] === null || queryRow.minMaxEv[0] === undefined) {
					queryRow.minMaxEv[0] = -1000;
				}
				if (queryRow.minMaxEv[1] === '' || queryRow.minMaxEv[1] === null || queryRow.minMaxEv[1] === undefined) {
					queryRow.minMaxEv[1] = 1000;
				}
				// Convert to numbers
				queryRow.minMaxEv = queryRow.minMaxEv.map((e) => Number(e));
			}

			for (const league of row.leagues) {
				queryRow.league.push(league);
			}
			for (const sport of row.sports) {
				queryRow.sport.push(sport);
			}
			for (const mkt of row.markets) {
				queryRow.market.push(mkt);
			}
			for (const mkt of row.marketTypes) {
				queryRow.marketType.push(mkt);
			}
			for (const mkt of row.sportsbooks) {
				pushSportsbooksToQueryField(queryRow, 'book', mkt);
			}
			// for (const mkt of row.sharpBooks) {
			// 	if (mkt.value === 'FanDuel') {
			// 		queryRow.sharp.push('Betway (Alaska)');
			// 	} else {
			// 		queryRow.sharp.push(mkt.value);
			// 	}
			// }

			queryRows.push(queryRow);
		}

		// const evScreenSubmitRes = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ev_screen?email=${email}&is_live=${is_live}&queryRows=${JSON.stringify(queryRows)}`, {
		// 	headers: {
		// 		Authorization: `Bearer ${token}`,
		// 	},
		// });
		// return evScreenSubmitRes;

		const evResults = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/arbitrage_results?email=${email}&is_live=${is_live}&queryRows=${JSON.stringify(queryRows)}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return evResults.data;
	} catch (e) {
		console.error('ev screen e: ', e);
		return false;
	}
};
